const DEFAULT_REGEX = /[-_]+(.)?/g
const toUpper = (match, group1) => (group1 ? group1.toUpperCase() : "")

export default function camelCase(str, delimiters) {
  return str.replace(delimiters ? new RegExp("[" + delimiters + "]+(.)", "g") : DEFAULT_REGEX, toUpper)
}
